import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Row, CardBody, Card } from 'reactstrap';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import BusinessIcon from '@mui/icons-material/Business';
import BadgeIcon from '@mui/icons-material/Badge';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import HubIcon from '@mui/icons-material/OtherHouses';
import RadioSelectTable from 'src/shared/components/table/RadioSelectTable';

const USER_COLUMNS = [
  {
    key: 'fullName',
    header: 'Full Name',
    sortable: true,
  },
  {
    key: 'userName',
    header: 'User Name',
    sortable: true,
  },
  {
    key: 'emailId',
    header: 'Email',
    sortable: true,
  },
];

const HubOperatorsTableView = ({ reactTableData, isNoRecordFound }) => {
  const rows = reactTableData?.tableRowsData ?? [];

  const [selectedUser, setSelectedUser] = useState(
    rows.length > 0 ? rows[0] : null
  );

  return (
    <Col md={12} lg={12} style={{ marginTop: '20px' }}>
      <Row>
        {/* ── Left: Master List ───────────────────────────── */}
        <Col md={7} lg={7}>
          <RadioSelectTable
            rows={rows}
            columns={USER_COLUMNS}
            rowKey="userId"
            selectedKey={selectedUser?.userId}
            onSelect={setSelectedUser}
            searchKeys={['fullName', 'userName', 'emailId', 'mobileNo']}
            searchPlaceholder="Search by Name, Username, Email..."
            sortKey="fullName"
            headerTitle="Hub Operator Accounts"
            pageSizes={[5, 10, 20, 50]}
          />
        </Col>

        {/* ── Right: Detail Panel ─────────────────────────── */}
        <Col md={5} lg={5}>
          <Card style={{
            borderRadius: '12px',
            border: '1px solid #e2e8f0',
            boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)',
            minHeight: '520px',
            background: '#ffffff',
            overflow: 'hidden',
          }}>
            {selectedUser ? (
              <>
                {/* Header Banner */}
                <div style={{
                  background: 'linear-gradient(135deg, #0284c7 0%, #0369a1 100%)',
                  padding: '24px 20px',
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <AccountCircleIcon style={{ color: '#ffffff', fontSize: '2.5rem', opacity: 0.9 }} />
                      <div>
                        <h4 style={{ margin: 0, fontWeight: 800, fontSize: '1.2rem', color: '#ffffff' }}>
                          {selectedUser.fullName}
                        </h4>
                        <span style={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.85)' }}>
                          @{selectedUser.userName}
                        </span>
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                      <span
                        className={`badge ${selectedUser.active ? 'bg-success' : 'bg-danger'}`}
                        style={{ fontSize: '0.75rem', fontWeight: 700 }}
                      >
                        {selectedUser.active ? 'ACTIVE' : 'IN-ACTIVE'}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Details Body */}
                <CardBody style={{ padding: '20px' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>

                    {/* Account Details */}
                    <div>
                      <h6 className="text-muted text-uppercase fw-bold mb-2"
                        style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>
                        Account Details
                      </h6>
                      <div style={{ background: '#f8fafc', borderRadius: '8px', padding: '12px 14px', border: '1px solid #f1f5f9', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted small">Client Name:</span>
                          <span className="fw-bold small text-dark d-flex align-items-center gap-1">
                            <BusinessIcon style={{ fontSize: '14px', color: '#64748b' }} />
                            {selectedUser.customerInfo?.clientName || selectedUser.customerName || '—'}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted small">User Role:</span>
                          <span className="fw-bold small text-dark d-flex align-items-center gap-1">
                            <BadgeIcon style={{ fontSize: '14px', color: '#64748b' }} />
                            {selectedUser.userRoleInfo?.name || selectedUser.roleName || 'Hub Operator'}
                          </span>
                        </div>
                        {selectedUser.hubName && (
                          <div className="d-flex justify-content-between">
                            <span className="text-muted small">Assigned Hub:</span>
                            <span className="fw-bold small text-dark d-flex align-items-center gap-1">
                              <HubIcon style={{ fontSize: '14px', color: '#64748b' }} />
                              {selectedUser.hubName}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Contact Details */}
                    <div>
                      <h6 className="text-muted text-uppercase fw-bold mb-2"
                        style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>
                        Contact Details
                      </h6>
                      <div style={{ background: '#f8fafc', borderRadius: '8px', padding: '12px 14px', border: '1px solid #f1f5f9', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted small">Email Address:</span>
                          <span className="fw-bold small text-dark d-flex align-items-center gap-1">
                            <EmailIcon style={{ fontSize: '14px', color: '#64748b' }} />
                            {selectedUser.emailId || '—'}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted small">Mobile No:</span>
                          <span className="fw-bold small text-dark d-flex align-items-center gap-1">
                            <PhoneIcon style={{ fontSize: '14px', color: '#64748b' }} />
                            {selectedUser.mobileNo || '—'}
                          </span>
                        </div>
                      </div>
                    </div>

                  </div>
                </CardBody>
              </>
            ) : (
              <div style={{
                display: 'flex', flexDirection: 'column', alignItems: 'center',
                justifyContent: 'center', padding: '40px', textAlign: 'center', minHeight: '520px',
              }}>
                <div style={{ fontSize: '3.5rem', color: '#cbd5e1', marginBottom: '16px' }}>👥</div>
                <h5 className="fw-bold text-muted">No Operator Selected</h5>
                <p className="text-muted small">Select an operator account from the list to view specifications.</p>
              </div>
            )}
          </Card>
        </Col>
      </Row>
    </Col>
  );
};

HubOperatorsTableView.propTypes = {
  reactTableData: PropTypes.shape({
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
  }),
  isNoRecordFound: PropTypes.bool,
};

export default HubOperatorsTableView;
